import React from "react";
import { Form } from "react-bootstrap";

type Props = {
	as: "input" | "textarea";
	handleClose: () => void;
	handleSubmit: (submitValue: string) => void | Promise<void>;
	initialValue: string;
};

export const HideInputInnerForm: React.FC<Props> = ({
	initialValue,
	handleClose,
	handleSubmit,
	as
}: Props) => {
	const inputRef = React.useRef<HTMLInputElement | null>(null);
	const [value, setValue] = React.useState<string>(initialValue);
	React.useEffect(() => {
		inputRef?.current?.focus();
	}, []);
	const onSubmit = async (e: React.FormEvent): Promise<void> => {
		e.preventDefault();
		await handleSubmit(value);
		handleClose();
	};
	const onKeyDown = async (e: React.KeyboardEvent): Promise<void> => {
		if (e.key === "Escape") {
			handleClose();
		}
	};
	const onBlur = async (): Promise<void> => {
		await handleSubmit(value);
		handleClose();
	};
	const onChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
		setValue(e.target.value);
	};
	return (
		<Form onSubmit={onSubmit}>
			<Form.Control
				as={as}
				onBlur={onBlur}
				onChange={onChange}
				onKeyDown={onKeyDown}
				ref={inputRef}
				value={value ?? ""}
			/>
		</Form>
	);
};
